import { Box } from "@chakra-ui/react";

let StructuredDataInsert = ({ data }) => {

    return <Box>
        <script
            key="structured-data"
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
    </Box>

}

export default StructuredDataInsert;